import { render, staticRenderFns } from "./SysForm.vue?vue&type=template&id=0fb66b50&scoped=true"
import script from "./SysForm.vue?vue&type=script&lang=js"
export * from "./SysForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb66b50",
  null
  
)

export default component.exports